import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Scale, ArrowLeft } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password/', { email });
      setSent(true);
      toast.success('Reset instructions sent!');
    } catch {
      toast.error('Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400 rounded-2xl mb-4 shadow-lg">
            <Scale size={32} className="text-blue-950" />
          </div>
          <h1 className="text-3xl font-bold text-white">Legal CMS</h1>
          <p className="text-blue-300 mt-1 text-sm">Reset your password</p>
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <span className="text-3xl">&#10003;</span>
              </div>
              <h2 className="text-xl font-bold text-gray-800">Check your email</h2>
              <p className="text-gray-500 text-sm">If this email is registered, you will receive a password reset link.</p>
              <Link to="/login" className="block text-blue-700 text-sm hover:underline">Back to Sign In</Link>
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2 mb-6">
                <Link to="/login" className="text-gray-400 hover:text-gray-600"><ArrowLeft size={18}/></Link>
                <h2 className="text-xl font-bold text-gray-800">Forgot Password</h2>
              </div>
              <p className="text-gray-500 text-sm mb-5">Enter your registered email address and we'll send you password reset instructions.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <button type="submit" disabled={loading}
                  className="w-full bg-blue-950 hover:bg-blue-800 text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-60">
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
